import cdn from "@/services/cdn"

class Media {
  constructor() {
    this.request_ = this.status = null
    this.player = null
    this.source = null
    this.loop = false
    this.type = null
    this.dvr = false

    this.previous = {
      player: null,
      source: null,
      loop: false,
      type: null
    }
  }
  async _init() {
    return true
  }

  async request(payload = null) {
    if (!payload && this.request_?.data) return __.media.play(this.request_.data, this.request_.loop ? "background" : false, this.request_.params)
    else if (payload) this.request_ = { data: payload?.data || this.source, loop: payload?.loop || this.loop, params: payload?.params || this.params }

    this._resetSource()
    return true
  }

  async play(data = null, loop = false, params = {}) {
    try {
      if (!__.device.isPowerOn()) return this.request({ data, loop })
      else this.request_ = null

      if (!__.platform.focus) return false
      this.dvr = false

      if (loop === "background") loop = true
      else if (__.platform.hasBackground()) __.platform.background()

      if (!data) return _$.log("Invalid source", false)

      data = await this._convertCDN(data)

      const type = this._detectType(data)
      if (!type) return _$.log("Invalid source type", false)

      if (!__[`_${type}`] && !__[`_${type.toLowerCase()}`]) {
        await this.stop()
        _$.vue.$emit("mediaError", { type: "mediaError" })
        return _$.log(`Current bridge doesn't support "${type}"`, false)
      }

      const forceDestroy = this.status === "playing"
      this._resetSource()
      this.player = __[`_${type}`] || __[`_${type.toLowerCase()}`]
      this.status = "start"
      this.source = data
      this.loop = loop
      this.type = type

      this._startEvent()
      await this._switchPlayer(forceDestroy)

      const res = await this.player.play(this.source, params).catch(err => _$.error(err))

      if (!res) {
        this.status = "error"
        return _$.log(`Something went wrong while trying to play.`, false)
      }

      return res
    } catch (err) {
      return _$.error(err)
    }
  }
  async stop(dontTouchDvr = false) {
    if (!this.isActive()) return false
    return this.player
      .stop(this.source)
      .then(res => {
        if (!dontTouchDvr) this.dvr = false
        return res
      })
      .catch(err => _$.error(err))
  }
  async destroy() {
    if (!this.hasPlayer()) return false

    return this.player
      .destroy()
      .then(data => data && this._resetSource(true))
      .catch(err => _$.error(err))
  }
  async pause() {
    if (!this.isPlaying()) return false
    return this.player.pause(this.source).catch(err => _$.error(err))
  }
  async continue() {
    if (!this.isPaused()) return false
    return this.player.continue(this.source).catch(err => _$.error(err))
  }

  async _convertCDN(source) {
    if (__.device.config("remoteClient") && _$.true(__.device.config("cdn.driver"))) {
      const res = await cdn.convert(source.trim())
      if (!res) return _$.error("The CDN driver can't handle this url.", source)
      else return res
    }
    return source
  }
  async _startEvent() {
    _$.vue.$emit("media")
    return true
  }
  async _switchPlayer(forceDestory) {
    if (this.player === this.previous.player) return true
    _$.log("Switching player...")

    if (this.previous.player) await this.previous.player.destroy(forceDestory).catch(err => _$.error(err))

    return this.player.start().catch(err => _$.error(err))
  }
  _resetSource(hard = false) {
    this.previous.player = hard ? null : this.player
    this.previous.source = hard ? null : typeof this.source === "object" ? _$.clone(this.source) : this.source
    this.previous.loop = hard ? null : this.loop
    this.previous.type = hard ? null : this.type

    this.status = null
    this.player = null
    this.source = null
    this.loop = null
    this.type = null

    return true
  }
  _convertDVB(params) {
    const map = {
      S: "satelliteID",
      F: "frequency",
      BT: "broadcastType",
      SR: "symbolRate",
      PL: "polarization",
      PID: "programNumber"
    }

    const re = /[\s,=,;]+/
    const nameList = params.split(re)

    var object = {}
    for (var i = 0; i < nameList.length; i++) {
      object[map[nameList[i]]] = nameList[++i]
    }
    return object
  }
  _detectType(source) {
    // Trying for RF
    const tempDVB = this._convertDVB(source)
    if (tempDVB.frequency) return "RF"
    else if (typeof source !== "string") return null

    // Trying for Multicast
    let multicastChecker = source.split(":").shift()
    if (["udp", "rtp", "rtmp"].indexOf(multicastChecker.toLowerCase()) !== -1) return "multicast"

    // Trying for VOD
    let vodChecker = source.split(".").pop()
    if (["mp4", "mkv", "avi", "ts", "ps"].indexOf(vodChecker.toLowerCase()) !== -1) return "vod"

    // Trying for HLS
    let hlsChecker = source.split(":").shift()
    if (["http", "https", "rtsp", "hls"].indexOf(hlsChecker.toLowerCase()) !== -1) return "hls"

    if (source.includes("flussonic")) return "hls"
    return null
  }
  _checkSame(source, type) {
    if (type === "RF") if (_$.clone(this.previous.source) === _$.clone(source)) return true

    if (source === this.previous.source) return true

    return false
  }
  getState() {
    return {
      status: this.status,
      source: this.source,
      type: this.type,
      loop: this.loop
    }
  }
  isActive() {
    if (!this.hasPlayer()) return false
    if (["playing", "paused"].indexOf(this.status) < 0) return false
    else return true
  }
  isPlaying() {
    if (!this.hasPlayer()) return false
    return this.status === "playing"
  }
  isPaused() {
    if (!this.hasPlayer()) return false
    return this.status === "paused"
  }
  isEnded() {
    if (!this.hasPlayer()) return false
    return this.status === "ended"
  }
  isStopped() {
    if (!this.hasPlayer()) return false
    return this.status === "stopped"
  }
  hasError() {
    if (!this.hasPlayer()) return false
    return this.status === "error"
  }
  hasPlayer() {
    return this.player ? true : false
  }
  getLoop() {
    return this.loop
  }
  getSource() {
    return this.source
  }

  /* Control Helpers */
  async isSeekable() {
    if (!this.isPlaying()) return false
    return this.player.isSeekable().catch(err => _$.error(err))
  }
  async getDuration() {
    if (!this.isPlaying()) return false
    return this.player.getDuration().catch(err => _$.error(err))
  }
  async getPosition() {
    if (!this.isPlaying()) return false
    return this.player.getPosition().catch(err => _$.error(err))
  }
  async setPosition(second) {
    let res = false
    if (!this.isPlaying()) res = await this.continue()
    else res = true

    if (!res) return false
    return this.player.setPosition(second).catch(err => _$.error(err))
  }
  async getSubtitles() {
    if (!this.isPlaying()) return false
    return this.player.getSubtitles().catch(err => _$.error(err))
  }
  async getLanguages() {
    if (!this.isPlaying()) return false

    return this.player.getLanguages().catch(err => _$.error(err))
  }
  async setSubtitle(pid) {
    if (!this.isPlaying()) return false
    return this.player.setSubtitle(pid).catch(err => _$.error(err))
  }
  async setLanguage(pid) {
    if (!this.isPlaying()) return false
    return this.player.setLanguage(pid).catch(err => _$.error(err))
  }
  async closeSubtitle() {
    if (!this.isPlaying()) return false
    return this.player.closeSubtitle().catch(err => _$.error(err))
  }

  /* Helpers */
  async pinCodeMiddleware(entity) {
    let behaviour = __.device.config("channel_pin_code_behaviour.channel_pin_code_behaviour") || 0
    behaviour = parseInt(behaviour)

    if (!behaviour || window.sessionStorage.getItem(entity.channel_uri || entity.url)) return true

    const result = await _$.vue.$interact.prompt(_$.vue.$t("Restricted Content"), _$.vue.$t("Please Enter PIN Code"), "right", [
      { type: "input", id: "pin", fluid: true, label: _$.vue.$t("PIN Code") }
    ])
    if (!result) return false
    if (result.pin.value != entity.pin) return this.pinCodeMiddleware(entity)

    if (behaviour === 1) window.sessionStorage.setItem(entity.channel_uri || entity.url, true)

    return true
  }
}

export default new Media()
